











import { Component, Vue } from 'vue-property-decorator'
@Component
export default class extends Vue {
  get matchedRoutes() {
    const arr = this.$route.matched.map(item => {
      if (!item?.name) {
        item.name = 'PortalHome'
      }
      return item
    })
    return arr
  }
}
